import React from "react";
import { Swords } from "lucide-react";

export default function ScoreBar({ me, opponent, myScore, oppScore }) {
  const total = myScore + oppScore || 1;
  const myPct = Math.round((myScore / total) * 100);
  return (
    <div className="glass-panel rounded-2xl p-4" data-testid="duel-score-bar">
      <div className="flex items-center justify-between text-sm mb-2">
        <span className="font-semibold text-indigo-300 truncate max-w-[40%]" data-testid="duel-my-name">{me} <span className="text-slate-400 font-normal">(You)</span></span>
        <Swords className="w-4 h-4 text-slate-400 shrink-0" />
        <span className="font-semibold text-rose-300 truncate max-w-[40%] text-right" data-testid="duel-opponent-name">{opponent}</span>
      </div>
      <div className="h-3 rounded-full bg-white/5 overflow-hidden flex">
        <div className="h-full bg-indigo-400 transition-all duration-500" style={{ width: `${myPct}%` }} />
        <div className="h-full bg-rose-400 transition-all duration-500" style={{ width: `${100 - myPct}%` }} />
      </div>
      <div className="flex items-center justify-between text-xs mt-1.5 font-bold">
        <span className="text-indigo-300" data-testid="duel-my-score">{myScore} pts</span>
        <span className="text-rose-300" data-testid="duel-opponent-score">{oppScore} pts</span>
      </div>
    </div>
  );
}
